<mat-divider></mat-divider>
<ng-scrollbar id="vertical-menu" pointerEventsMethod="scrollbar">
    <app-vertical-menu [menuItems]="menuItems" [menuParentId]="0"></app-vertical-menu>
</ng-scrollbar>
